(function () {
  'use strict';

  angular.module('sempraWebapp').service('checkUserRole', checkUserRoleService);

  /** @ngInject */
  function checkUserRoleService(
    sessionData,
    userRolesEnum,
    brand
  ) {
    var role = sessionData.getValue('userRole');

    this.setCurrentRoles = function (userRoles) {
      role = userRoles;
    };

    this.userRoleExist = function (userRoles) {
      var currentRoles = userRoles || role;

      if (brand === 'karcher') {
        return (
          currentRoles.includes(userRolesEnum.FACILITY_ADMIN) ||
          currentRoles.includes(userRolesEnum.MERCHANT_ADMIN) ||
          currentRoles.includes(userRolesEnum.CONTROLLER) ||
          currentRoles.includes(userRolesEnum.TECHNICAL_SUPPORT) ||
          currentRoles.includes(userRolesEnum.ADMINISTRATOR)
        );
      } else {
        return (
          currentRoles.includes(userRolesEnum.FACILITY_ADMIN) ||
          currentRoles.includes(userRolesEnum.MERCHANT_ADMIN)
        );
      }
    };


    this.hasAcceptNewTerms = function (array) {
      return array.includes('ACCEPT_TERMS_AND_CONDITIONS') && !this.userRoleExist(array);
    };

    this.isFacilityAdmin = function () {
      return role.includes(userRolesEnum.FACILITY_ADMIN);
    };

    this.isMerchantAdmin = function () {
      return role.includes(userRolesEnum.MERCHANT_ADMIN);
    };

    this.isControllerUser = function () {
      return role.includes(userRolesEnum.CONTROLLER);
    };

    this.isTechnicalSupportUser = function () {
      return role.includes(userRolesEnum.TECHNICAL_SUPPORT);
    };

    this.isAdministrator = function () {
      return role.includes(userRolesEnum.ADMINISTRATOR);
    };
  }
})();
